import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Input from "../../components/global/Input";
import Button from "../../components/global/Button";
import {
  useGetAllClubsByNameQuery,
  useGetAllClubsQuery,
} from "../../lib/redux/services/sections/Clubs";
import { useLoginMutation } from "../../lib/redux/services/sections/Auth";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { EmailValidate, toastMessage } from "../../utils/utils";
import ValidateError from "../global/ValidateError";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import { useGetMyProfileQuery } from "../../lib/redux/services/sections/Profile";
import { useDispatch } from "react-redux";
import { selectClubThunk, setUser } from "../../lib/redux/slices/userSlice";
import EyeClosedIcon from "../../assets/icons/EyeClosedIcon";
import EyeOpenedIcon from "../../assets/icons/EyeOpenedIcon";

type FormInput = {
  email: string;
  password: string;
};

const LoginForm = () => {
  const { Auth, inputs, shared }: DictionaryType = useGetDictionary();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [callRequestData, setCallRequestData] = useState(false);
  const [login] = useLoginMutation();
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("token")
  );

  // Fetch clubs data only when the token is available
  const { data: clubs, refetch } = useGetAllClubsByNameQuery("", {
    skip: !token, // Skip query if token is not available
  });

  const { data: profile, refetch: refetchProfile } = useGetMyProfileQuery("", {
    skip: !token, // Skip query if token is not available
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>();

  const onSubmit = async (formData: FormInput) => {
    try {
      const data = await toast.promise(
        login({
          ...formData,
          email: formData?.email?.toLowerCase(),
          fcm_token: localStorage.getItem("fcmToken"),
        }).unwrap(),
        toastMessage()
      );
      console.log(data);

      // Store token and user data
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("mocion-admin-id", data.user.uid);

      // Update token state to trigger the clubs fetch
      setToken(data.access_token);
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  // Re-fetch clubs when the token changes
  useEffect(() => {
    if (token) {
      refetch();
      refetchProfile();
    }
  }, [token, refetch]);

  if (clubs && profile) {
    localStorage.setItem(
      "clubId",
      JSON.stringify(clubs?.data.length > 0 ? clubs.data[0].id : "")
    );
    console.log("from login", profile?.data);

    dispatch(setUser(profile.data));
    //@ts-ignore
    dispatch(selectClubThunk(clubs?.data[0]?.id || 0))
    localStorage.setItem("clubs", JSON.stringify(clubs?.data));
    
    if (profile?.data?.stage == "approved") navigate("/home?viewType=court");
    else navigate("/club-settings/organization");
  } else {
  }
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="space-y-4 md:space-y-6 max-w-[814px] px-5 py-5"
    >
      <div className="mt-6 flex text-start flex-col items-center justify-center gap-6 w-full">
        <div className="w-full">
          <Controller
            name="email"
            rules={{
              required: true,
              pattern: {
                value: EmailValidate,
                message: shared.Invalid_email_domain_messsage,
              },
            }}
            control={control}
            render={({ field }) => (
              <Input
                inputProps={{
                  ...field,
                  type: "text",
                }}
                label={inputs.email}
              />
            )}
          />
          {errors.email && (
            <ValidateError errorMessage={errors.email.message} />
          )}
        </div>
        <div className="w-full">
          <Controller
            name="password"
            rules={{ required: true }}
            control={control}
            render={({ field }) => (
              <Input
                inputProps={{
                  ...field,
                  type: "password",
                }}
                label={inputs.password}
                icon={EyeClosedIcon}
                toggleIcon={EyeOpenedIcon}
              />
            )}
          />
          {errors.password && errors.password.type === "required" && (
            <ValidateError />
          )}
        </div>
        <div className="flex flex-row gap-1 w-full justify-between">
          {/* <div className="flex flex-row gap-1 w-full items-center">
            <input type="checkbox" className="accent-primary" />
            <label className="text-sm" htmlFor="">
              {Auth?.login_page.remember_me}
            </label>
          </div> */}
          <Link
            to={"/auth/forget-password-request"}
            className="flex flex-row gap-1 w-full items-end justify-end"
          >
            <p className="text-primaryRed  text-sm ">
              {Auth?.forget_password.forget_password}?
            </p>
          </Link>
        </div>
        <Button
          customeStyle="bg-primary text-white w-full rounded-full text-sm py-3 font-bold"
          text={Auth?.login}
          width="max-w-[350px] w-full"
          type="submit"
        />
      </div>
    </form>
  );
};

export default LoginForm;
